import React from 'react';
import styled from 'styled-components';
import Modal from '../../shared/components/ui/Modal';
import AppButton from '../../shared/components/ui/AppButton';
import { COLORS } from '../../theme/Colors';

interface EnrollmentConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  courseName: string;
  selectedDate: Date | null;
  selectedTimeSlot: string | null;
  isLoading?: boolean;
}

const EnrollmentConfirmationModal: React.FC<EnrollmentConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  courseName,
  selectedDate,
  selectedTimeSlot,
  isLoading = false,
}) => {
  if (!isOpen || !selectedDate || !selectedTimeSlot) {
    return null;
  }

  const formattedDate = selectedDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContentWrapper>
        <ConfirmationTitle>Confirm Enrollment</ConfirmationTitle>
        <ConfirmationText>
          Are you sure you want to enroll in <strong>{courseName}</strong> on <br />
          <strong>{formattedDate}</strong> at <strong>{selectedTimeSlot}</strong>?
        </ConfirmationText>
        <ButtonContainer>
          <AppButton
            title="Cancel"
            onClick={onClose}
            style={{ backgroundColor: COLORS.textMuted}}
            disabled={isLoading}
          />
          <AppButton
            title={isLoading ? "Confirming..." : "Confirm"}
            onClick={onConfirm}
            disabled={isLoading}
            style={{ backgroundColor: COLORS.accent }}
          />
        </ButtonContainer>
      </ModalContentWrapper>
    </Modal>
  );
};

export default EnrollmentConfirmationModal;

const ModalContentWrapper = styled.div`
  padding: 32px;
  text-align: center;
  background-color: ${COLORS.white};
  color: ${COLORS.textDark};
  border-radius: 16px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const ConfirmationTitle = styled.h2`
  color: ${COLORS.primary};
  font-size: 24px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 20px;
`;

const ConfirmationText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
  color: ${COLORS.textDark};

  strong {
    color: ${COLORS.primary};
    font-weight: 600;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  & > button {
    min-width: 120px;
    width: auto;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
    
    @media (max-width: 480px) {
      min-width: 100px;
      padding: 10px 20px;
    }
  }
`;
